import { BasePortal, MainLoading, RouterGuard } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Test from '../pages/Test';
import { routes, toRelativePath } from './routes';

import AcademicCalendar from '../pages/AcademicCalendar';
import SchoolDay from '../pages/SchoolDay';
// US1 Pages
import SchoolStructure from '../pages/SchoolStructure';

import StaffRoles from '../pages/StaffRoles';
// US2 Pages
import Teachers from '../pages/Teachers';

// US3 Pages
import CurriculumPlans from '../pages/CurriculumPlans';
import Groupings from '../pages/Groupings';
import Subjects from '../pages/Subjects';

// US4 Pages
import Students from '../pages/Students';

// US5 Pages
import AutomationProfiles from '../pages/AutomationProfiles';
import HardRules from '../pages/HardRules';
import Preferences from '../pages/Preferences';
import SoftRules from '../pages/SoftRules';
import TeacherPreferences from '../pages/TeacherPreferences';

// US6 Pages
import AutomationSettings from '../pages/AutomationSettings';
import GenerateTimetable from '../pages/GenerateTimetable';
import GenerationHistory from '../pages/GenerationHistory';

// US7 Pages
import EditTimetable from '../pages/EditTimetable';

// US8 Pages
import Conflicts from '../pages/Conflicts';

// US9 Pages
import ViewTimetable from '../pages/ViewTimetable';

// US10 Pages
import Simulations from '../pages/Simulations';

// US11 Pages
import Finalization from '../pages/Finalization';
import VersionHistory from '../pages/VersionHistory';

// US12 Pages
import ExportTimetables from '../pages/ExportTimetables';
import PortalPreview from '../pages/PortalPreview';

// Dashboard
import Dashboard from '../pages/Dashboard';
import NotFound from '../../portal/pages/not-found';

export function ZoneRoutes() {
  return (
    <Routes>
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.dashboard} />} />
      <Route
        element={<BasePortal sidebar microSystem showUserRole miniSidebar={true} navbar={true} sidebarHeader={true} />}
      >
        <Route path="*" element={<Suspense fallback={<MainLoading />}>
          <NotFound />
        </Suspense>} />
        <Route
          path={toRelativePath(routes.test)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Test />
            </Suspense>
          }
        />

        {/* Dashboard */}
        <Route
          path={toRelativePath(routes.dashboard)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Dashboard />
            </Suspense>
          }
        />

        {/* US1: School Structure Configuration */}
        <Route
          path={toRelativePath(routes.schoolSetup.structure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructure />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.schoolSetup.day)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolDay />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.schoolSetup.calendar)}
          element={
            <Suspense fallback={<MainLoading />}>
              <AcademicCalendar />
            </Suspense>
          }
        />

        {/* US2: Teacher and Staff Management */}
        <Route
          path={toRelativePath(routes.people.teachers)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Teachers />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.people.roles)}
          element={
            <Suspense fallback={<MainLoading />}>
              <StaffRoles />
            </Suspense>
          }
        />

        {/* US3: Curriculum and Subject Management */}
        <Route
          path={toRelativePath(routes.curriculum.subjects)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Subjects />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.curriculum.plans)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumPlans />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.curriculum.groupings)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Groupings />
            </Suspense>
          }
        />

        {/* US4: Student Grouping Configuration */}
        <Route
          path={toRelativePath(routes.people.students)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Students />
            </Suspense>
          }
        />

        {/* US5: Rules and Constraints Management */}
        <Route
          path={toRelativePath(routes.rules.hard)}
          element={
            <Suspense fallback={<MainLoading />}>
              <HardRules />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.rules.soft)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SoftRules />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.rules.preferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Preferences />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.rules.teacherPreferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeacherPreferences />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.rules.profiles)}
          element={
            <Suspense fallback={<MainLoading />}>
              <AutomationProfiles />
            </Suspense>
          }
        />

        {/* US6: Automated Timetable Generation */}
        <Route
          path={toRelativePath(routes.generator.generate)}
          element={
            <Suspense fallback={<MainLoading />}>
              <GenerateTimetable />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.generator.history)}
          element={
            <Suspense fallback={<MainLoading />}>
              <GenerationHistory />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.generator.settings)}
          element={
            <Suspense fallback={<MainLoading />}>
              <AutomationSettings />
            </Suspense>
          }
        />

        {/* US7: Manual Timetable Editing */}
        <Route
          path={toRelativePath(routes.timetable.edit)}
          element={
            <Suspense fallback={<MainLoading />}>
              <EditTimetable />
            </Suspense>
          }
        />

        {/* US8: Conflict Detection and Resolution */}
        <Route
          path={toRelativePath(routes.timetable.conflicts)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Conflicts />
            </Suspense>
          }
        />

        {/* US9: Timetable Views and Filters */}
        <Route
          path={toRelativePath(routes.timetable.view)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ViewTimetable />
            </Suspense>
          }
        />

        {/* US10: What-If Simulations */}
        <Route
          path={toRelativePath(routes.simulations)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Simulations />
            </Suspense>
          }
        />

        {/* US11: Version Management and Finalization */}
        <Route
          path={toRelativePath(routes.versions.history)}
          element={
            <Suspense fallback={<MainLoading />}>
              <VersionHistory />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.versions.finalize)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Finalization />
            </Suspense>
          }
        />

        {/* US12: Export and Distribution */}
        <Route
          path={toRelativePath(routes.export.timetables)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ExportTimetables />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.export.preview)}
          element={
            <Suspense fallback={<MainLoading />}>
              <PortalPreview />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
